import { Outlet } from 'react-router-dom';
import LightModeTheme from '../../theme/LightModeTheme';
import MainNavbar from './MainNavbar';

export default function MainLayout() {
  return (
    <LightModeTheme>
      <MainNavbar />
      <div>
        <Outlet />
      </div>
    </LightModeTheme>
  );
}
